import {
  Eye,
  EyeOff,
} from 'lucide-react';
import {
  type InputHTMLAttributes,
  useState,
} from 'react';

// A password field with a button to show what was typed, to check a long
// passphrase or a pasted token. Shown as text, a phone keyboard would
// otherwise capitalise and autocorrect it.
export const PasswordInput = (
  props: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>,
) => {
  const [shown, setShown] = useState(false);
  const Icon = shown ? EyeOff : Eye;
  return (
    <span className="password-input">
      <input
        autoCapitalize="off"
        autoCorrect="off"
        spellCheck={false}
        {...props}
        type={shown ? 'text' : 'password'} />
      <button
        type="button"
        className="quiet"
        aria-label="Show password"
        aria-pressed={shown}
        // keeps the focus, and a phone's keyboard, on the field
        onPointerDown={e => e.preventDefault()}
        onClick={() => setShown(s => !s)}>
        <Icon aria-hidden="true" />
      </button>
    </span>
  );
};
